export default __webpack_public_path__ + "static/itinerary_block_picto-5de8932b6955bd9208bee8ef14ad30dc.png";